import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { EnVivo as Datos } from "../../../../services/v2/telefonia.service";
import { Aviso, errorTexto, hace, minutos, num, pct, plantelNombre, seg, telBonito } from "./comunes";
import { Compartido } from "./telefoniaController";
import { telefono } from "../../sales/telefono/telefono";

/** Supervisión en una llamada en curso (la central: *81 escuchar, *82 hablarle solo a la asesora, *83 unirse a los dos). */
const MODOS: { k: string; t: string; titulo: string }[] = [
	{ k: "81", t: "Escuchar", titulo: "Oyes la llamada; nadie te oye" },
	{ k: "82", t: "Susurrar", titulo: "Solo la asesora te oye; el cliente no" },
	{ k: "83", t: "Unirme", titulo: "Entras a la llamada: te oyen los dos" },
];

/** Supervisión en vivo: quién está conectada, quién está en llamada (y con quién), cuántos esperan por departamento. Se refresca cada 10 s. */
const EnVivo: React.FC<{ sh: Compartido }> = ({ sh }) => {
	const http = HttpManager.getInstance();
	const [d, setD] = useState<Datos | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [tick, setTick] = useState<number>(0);
	useEffect(() => {
		let vivo = true;
		const cargar = () => http.telefoniaService.enVivo(sh.campusId).then((r) => { if (vivo) setD(r.data); }).catch((e) => { if (vivo) setError(errorTexto(e)); });
		cargar();
		const t = setInterval(cargar, 10000);
		const reloj = setInterval(() => setTick((x) => x + 1), 1000);
		return () => { vivo = false; clearInterval(t); clearInterval(reloj); };
	}, [sh.campusId]);

	// El teléfono ya no se enciende a mano (siempre encendido): si se está reconectando, se reconecta y marca al quedar listo.
	const supervisar = async (ext: string, nombre: string, modo: { k: string; t: string }) => {
		setError(null);
		if (telefono.ocupado) return setError("Termina primero la llamada en la que estás.");
		// Entrando directo a Telefonía (sin pasar por CRM) el teléfono aún no sabe de dónde sacar la extensión.
		if (!telefono.listo) telefono.usarFuente(async () => { const r = await http.prospectsService.pbx(sh.campusId); return r.data.enabled ? r.data : null; });
		if (!(await telefono.llamarYa("*" + modo.k + ext, { name: modo.t + " · " + nombre }))) setError(telefono.error || "Tu teléfono de WAPP no logró conectarse. Vuelve a intentar en unos segundos.");
	};

	if (!d) return <div className="nu-vacio">Cargando…</div>;
	const conectadas = d.extensiones.filter((e) => e.online);
	const enLlamada = d.extensiones.filter((e) => e.llamada);
	const desde = d.at ? Math.round((Date.now() - new Date(d.at).getTime()) / 1000) : 0;

	return (
		<>
			<Aviso texto={error} onClose={() => setError(null)} />
			{!d.central_viva ? <Aviso texto="La central no ha reportado en los últimos 3 minutos: lo que ves puede estar viejo." /> : null}
			<div className="tf-kpis">
				<div className="nu-kpi"><span>Conectadas</span><b>{conectadas.length}</b><small>de {d.extensiones.length} extensiones</small></div>
				<div className={"nu-kpi" + (enLlamada.length ? "" : "")}><span>En llamada</span><b>{enLlamada.length}</b><small>ahora mismo</small></div>
				<div className={"nu-kpi" + (d.colas.some((c) => c.esperando) ? " oro" : "")}><span>Esperando en cola</span><b>{d.colas.reduce((a, c) => a + c.esperando, 0)}</b><small>máx. {Math.max(0, ...d.colas.map((c) => c.espera_max))} s</small></div>
				<div className="nu-kpi"><span>Hoy</span><b>{num(d.hoy.total)}</b><small>{num(d.hoy.salientes)} salientes · {num(d.hoy.entrantes)} entrantes</small></div>
				<div className="nu-kpi"><span>Contestadas hoy</span><b>{pct(d.hoy.contestadas, d.hoy.total)}</b><small>{minutos(d.hoy.hablado)} hablados</small></div>
				<div className={"nu-kpi" + (Number(d.hoy.perdidas) ? " oro" : "")}><span>Entrantes perdidas hoy</span><b>{num(d.hoy.perdidas)}</b><small>{d.at ? "actualizado hace " + desde + " s" : "sin reporte"}</small></div>
			</div>
			{d.colas.length ? (
				<div className="nu-bloque" style={{ marginBottom: 14 }}>
					<div className="nu-bloque-tit">Departamentos</div>
					<div className="tf-colas-vivo">
						{d.colas.map((c) => (
							<div key={c.code} className="nu-kpi"><span>{c.name}</span><b className={c.esperando ? "oro" : ""}>{c.esperando} esperando</b><small>{c.disponibles} libres de {c.miembros} · espera máx. {c.espera_max} s</small></div>
						))}
					</div>
				</div>
			) : null}
			<div className="nu-bloque">
				<div className="nu-bloque-tit">Asesoras <small>{conectadas.length} conectadas</small></div>
				<div className="tf-vivo">
					{[...d.extensiones].sort((a, b) => Number(!!b.llamada) - Number(!!a.llamada) || Number(b.online) - Number(a.online) || a.extension.localeCompare(b.extension)).map((e) => (
						<div key={e.extension} className={"tf-vivo-tarjeta" + (e.llamada ? " llamada" : "") + (!e.online ? " off" : "")}>
							<b><i className={"tf-punto " + (e.llamada ? "llamada" : e.online ? "on" : "")} />{e.name} <span className="nu-tenue">· {e.extension}</span></b>
							<small>{e.team ? e.team + " · " : ""}{plantelNombre(sh.cat, e.campus_id)}</small>
							{e.llamada ? (
								<>
									<span className="tf-reloj">{e.llamada.dir === "in" ? "Entrante" : "Llamando"} · {seg((e.llamada.since || 0) + (d.at ? Math.max(0, Math.round((Date.now() - new Date(d.at).getTime()) / 1000)) : 0) + tick * 0)}</span>
									<small>{telBonito(e.llamada.remote)}{e.llamada.state && e.llamada.state !== "Up" ? " · " + (e.llamada.state === "Ring" || e.llamada.state === "Ringing" ? "timbrando" : e.llamada.state) : ""}</small>
									{(d.puedoEscuchar || []).includes(e.extension) ? (
										<div className="tf-espiar">{MODOS.map((m) => <button key={m.k} className="nu-btn chico" title={m.titulo} onClick={() => supervisar(e.extension, e.name, m)}>{m.t}</button>)}</div>
									) : null}
								</>
							) : <small>{e.online ? "Libre" : "Desconectada · " + hace(e.last_seen_at)}</small>}
							<small>Hoy: {e.hoy.llamadas} llamadas · {e.hoy.contestadas} contestadas · {minutos(e.hoy.segundos)}{e.hoy.ultima ? " · última " + hace(e.hoy.ultima) : ""}</small>
						</div>
					))}
					{!d.extensiones.length ? <div className="nu-vacio">Nadie tiene extensión todavía.</div> : null}
				</div>
			</div>
		</>
	);
};

export default EnVivo;
